import React from 'react';
import styled from '../../styled';
import Theme from '../../themes/index';
const positionMap = {
    TOP: 0,
    RIGHT: 90,
    BOTTOM: 180,
    LEFT: 270,
};
const calculateWidth = (size, multiplier) => {
    const matchResult = size === null || size === void 0 ? void 0 : size.match(/px|em|rem|vh|vw/);
    const unit = matchResult ? matchResult[0] : '';
    const widthNumber = size ? parseFloat(size.replace(unit, '')) : 0;
    return `${widthNumber * multiplier}${unit}`;
};
export const StyledSvg = styled.svg `
  width: ${({ size, theme, aspectRatio = 1 }) => calculateWidth(theme.icons.size[size], aspectRatio)};
  height: ${({ size, theme }) => theme.icons.size[size]};
  transform: rotate(${({ deg }) => deg || 0}deg);
  fill: ${({ color }) => color};
`;
export const iconGenerator = (Component) => ({ size, color = 'INK_600', position = 'TOP', e2eId }) => (React.createElement(Component, { size: size, color: Theme.colors[color], deg: positionMap[position], e2eId: e2eId }));
//# sourceMappingURL=Icon.js.map